import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { Image } from '@pets-ui/Image/Image'
import { Link } from '@pets-ui/Link/Link'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import CsvFileIcon from '../../assets/icons/csv-file-icon.webp'
import { CSV_MAX_ROWS, CSV_TEMPLATE_URL } from '../../constants'
import { AiUploadedFile } from '../AiFileUploadPanel/AiUploadedFile'
import { DropZone } from '../DropZone/DropZone'

export interface AiCsvUploadPanelProps {
  files: File[]
  handleDrop: (acceptedFiles: File[]) => void
  handleRemovePendingFile: (index: number) => () => void
}

export const AiCsvUploadPanel = ({ files, handleDrop, handleRemovePendingFile }: AiCsvUploadPanelProps) => {
  const hasFiles = files.length > 0

  return (
    <Box flex={1} display="flex" flexDirection="column">
      <HStack gap={2} py={4} alignItems="center">
        <Text color={colors.grey600}>{`採購清單.csv，填寫最多支援 ${CSV_MAX_ROWS.toLocaleString()} 筆資料`}</Text>
        <Link href={CSV_TEMPLATE_URL} target="_blank" color={colors.blue600}>下載範本</Link>
      </HStack>
      {hasFiles
        ? (
          <VStack alignItems="center" flexWrap="wrap" gap={3}>
            {files.map((file, index) => (
              <AiUploadedFile
                key={index}
                fileName={file.name}
                fileSize={file.size}
                icon={<Image src={CsvFileIcon} />}
                onRemove={handleRemovePendingFile(index)}
              />
            ))}
          </VStack>
        )
        : (
          <DropZone
            onDrop={handleDrop}
            rootProps={{ height: '100%' }}
            displayText={(
              <VStack alignItems="center" gap={2.5}>
                <Text>拖曳或選擇 CSV 檔案上傳</Text>
                <Button variant="outlined" color="blue" width={80}>選擇檔案</Button>
              </VStack>
            )}
            accept={['.csv', 'text/csv']}
          />
        )}
    </Box>
  )
}
